import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import "../AllPrint.css";
import KurdishSoraniNumbersToWords from "kurdish-numbers-to-words/Sorani.js";
import { FaMapMarkerAlt, FaPhoneAlt, FaPhoneVolume } from "react-icons/fa";
class SellPrintKurdish extends Component {
 render() {
  const {
   lang,
   change_Lang,
   sell_invoice_obj,
   thirdcolor,
   primary_logo,
   user,
   footer_logo,
   index_sell_contract,
   name_krd,
  } = this.props;
  // Kurdish
  let numberWordsSorani1 =
   sell_invoice_obj.introduction !== undefined &&
   sell_invoice_obj.introduction !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.introduction)
    : "";
  let numberWordsSorani2 =
   sell_invoice_obj.lastPrice !== undefined &&
   sell_invoice_obj.lastPrice !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.lastPrice)
    : 0;
  let numberWordsSorani3 =
   sell_invoice_obj.reject !== undefined && sell_invoice_obj.reject !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.reject)
    : 0;
  let numberWordsSorani4 =
   sell_invoice_obj.pay !== undefined && sell_invoice_obj.pay !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.pay)
    : 0;
  let numberWordsSorani5 =
   sell_invoice_obj.fee !== undefined && sell_invoice_obj.fee !== null
    ? KurdishSoraniNumbersToWords.convert(sell_invoice_obj.fee)
    : 0;
  return (
   <>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    {/* New One */}
    <div className={`${lang === "en" ? "" : "container-fluid fk "}`}>
     <div className="row">
      <div className="col-12">
       <div className="conn">
        <div class="row mt-4">
         <div class="col-4">
          <p
           style={{
            fontSize: "22px",
            color: "#000",
            textAlign: "right",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           &nbsp;{change_Lang("date")} :&nbsp;
           <Time
            value={sell_invoice_obj.createdAt}
            format="hh:mm:ss"
            style={{
             fontSize: "22px",
             color: "#342800",
             fontWeight: "bold",
            }}
           />
           &nbsp;-{" "}
           <Time
            value={sell_invoice_obj.createdAt}
            format="YYYY-MM-DD"
            style={{
             fontSize: "22px",
             color: "#000",
             fontWeight: "bold",
            }}
           />
          </p>
         </div>
         <div class="col-4 d-flex justify-content-center">
          <p
           style={{
            fontSize: "24px",
            color: "#000",
            fontWeight: "bolder",
           }}
           class={`d-flex justify-content-center text-uppercase ${
            lang !== "en" ? "fk" : "fkp"
           } `}
          >
           ({change_Lang("sale and purchase contract")})
          </p>
         </div>
         <div class="col-4 text-right">
          <p
           style={{
            fontSize: "22px",
            color: "#000",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           {change_Lang("contract number")} # &nbsp;
           {index_sell_contract}&nbsp;
          </p>
         </div>
        </div>
        <div class="row">
         <div class="col-12">
          <div class="form-group row form-inline">
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk"
           >
            {change_Lang("First Party (Seller)")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.firstname}
            </label>
           </div>

           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk"
           >
            {change_Lang("Second Party (Buyer)_")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.secondname}
            </label>
           </div>
           {/* phone */}
           {/* <label
                        style={{
                          fontSize: "26px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                        class="col-sm-3 col-form-label fkk"
                      >
                        {change_Lang("phone_number")}:
                      </label>
                      <div class="col-sm-3">
                        <label
                          class="d-flex justify-content-start"
                          style={{ fontWeight: "bold", fontSize: "22px" }}
                        >
                          {sell_invoice_obj.phone1}
                        </label>
                      </div>

                      <label
                        style={{
                          fontSize: "26px",
                          color: "black",
                          fontWeight: "bold",
                        }}
                        class="col-sm-3 col-form-label fkk"
                      >
                        {change_Lang("phone_number")}:
                      </label>
                      <div class="col-sm-3">
                        <label
                          class="d-flex justify-content-start"
                          style={{ fontWeight: "bold", fontSize: "22px" }}
                        >
                          {sell_invoice_obj.phone2}
                        </label>
                      </div> */}
           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 col-form-label fkk"
           >
            {" "}
            {change_Lang("first_rule_place")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.available_id &&
              sell_invoice_obj.available_id.Place_ku}
            </label>
           </div>

           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 fkk col-form-label"
           >
            {change_Lang("Type of property")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {change_Lang(
              sell_invoice_obj.available_id &&
               sell_invoice_obj.available_id.Property
             )}
            </label>
           </div>

           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 fkk col-form-label"
           >
            {" "}
            {change_Lang("Number of property")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.available_id &&
              sell_invoice_obj.available_id.NOoFProperty}
            </label>
           </div>

           <label
            style={{
             fontSize: "26px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-3 fkk col-form-label"
           >
            {" "}
            {change_Lang("Area")}:
           </label>
           <div class="col-sm-3">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "22px" }}
            >
             {sell_invoice_obj.available_id &&
              sell_invoice_obj.available_id.Area}
             &nbsp;م<sup>2</sup>
            </label>
           </div>
          </div>
          <p
           style={{
            fontSize: "24px",
            color: "#fff",
            fontWeight: "bolder",
            borderRadius: "50px 0px 0px 0px",
           }}
           id="liniar"
           class="my-3 d-flex justify-content-center fk"
          >
           {change_Lang("agreement")}
          </p>
         </div>
        </div>
        <div className="row ">
         <div className="col-12">
          <table className="table">
           <tbody>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              1-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "23px",
               borderTop: "none",
              }}
             >
              پێشەکی گرێبەست بەشێکە لەم گرێبەستە و لێی جیا نابێتەوە.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              2-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "23px",
               borderTop: "none",
              }}
             >
              لایه‌نى یه‌كه‌م فرۆشیار / خاوه‌ن موڵك به‌ڕێز (
              {sell_invoice_obj.firstname}) ڕه‌زامه‌ندی ته‌واوى هه‌یه‌ له‌سه‌ر
              فرۆشتنى موڵكى خۆی به‌ ژماره‌ (
              {sell_invoice_obj.available_id &&
               sell_invoice_obj.available_id.NOoFProperty}
              ) به‌ ڕووبه‌رى (
              {sell_invoice_obj.available_id &&
               sell_invoice_obj.available_id.Area}
              ) م٢ كه‌ ده‌كه‌وێته‌ (
              {sell_invoice_obj.available_id &&
               sell_invoice_obj.available_id.Place_ku}
              ) به‌ كڕیار به‌ڕێز ({sell_invoice_obj.secondname}).
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              3-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "23px",
               borderTop: "none",
              }}
             >
              هەردوولا ڕێکەوتن لەسەر نرخی ئەو موڵکە کە بابەتی ئەم گرێبەستە بە
              بڕی پارەی (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj ? sell_invoice_obj.lastPrice : 0}
               required
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              &nbsp;({numberWordsSorani2}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "دۆلاری  ئەمریکی"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "(دولار)"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "دیناری عێراقی"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "(دینار)"
               : ""}
              )) .
             </td>
            </tr>

            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              4-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "23px",
               borderTop: "none",
              }}
             >
              لایه‌نى یه‌كه‌م خاوه‌ن موڵك / فرۆشیار بڕی (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj ? sell_invoice_obj.introduction : 0}
               required
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              &nbsp;({numberWordsSorani1}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "دۆلاری  ئەمریکی"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "(دولار)"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "دیناری عێراقی"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "(دینار)"
               : ""}
              )) پاره‌ى وه‌رگرت له‌ لایه‌نى دووه‌م وه‌كو پێشه‌كی ئه‌م گرێ
              به‌سته‌ له‌ كاتى واژوو كردنى گرێ به‌ست، وه‌ بڕی پاره‌ى (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj.pay}
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              &nbsp;
              {numberWordsSorani4}&nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "دۆلاری  ئەمریکی"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "(دولار)"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "دیناری عێراقی"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "(دینار)"
               : ""}
              ) له‌ ئه‌ستۆى لایه‌نى دووه‌م ماوه‌ تاكو به‌روارى به‌ناو كردنى
              موڵكى ئاماژه‌ پێكراوى سه‌ره‌وه‌.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              5-
             </th>
             <td
              style={{
               lineHeight: "1.4",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "22px",
               borderTop: "none",
              }}
             >
              پێویسته‌ له‌سه‌ر لایه‌نى دووه‌م ئه‌و بڕه‌ پاره‌یه‌ى كه‌ ماوه‌ له‌
              خاڵی ( 4 ) بدات به‌ لایه‌نى یه‌كه‌م له‌به‌رده‌م تۆمارى
              خانووبه‌ره‌ى هه‌ولێر له‌ كاتی ( اقرار ) وه‌رگرتن.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              6-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "23px",
               borderTop: "none",
              }}
             >
              پێویستە لەسەر لایەنی یەکەم دوای وەرگرتنی تەواوی ئەو پارەیەی کە
              ڕێکەوتنی لەسەر کراوە موڵکی ئاماژەپێکراو ڕادەستی لایەنی دووەم بکات
              بەبێ دروست بوونی هیچ گرفتێک.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               listStyleType: "circle",
              }}
             >
              7-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "23px",
               borderTop: "none",
              }}
             >
              پێویسته‌ لایه‌نى یه‌كه‌م له‌ به‌روارى (
              <Time
               value={sell_invoice_obj.duedate}
               format="YYYY-MM-DD"
               // style={{ color: "black" }}
              />
              ) موڵكه‌كه‌ ڕاده‌ستى لایه‌نى دووه‌م بكات، وه‌ له‌كاتى دواكه‌وتنى
              ڕاده‌ست كردنى موڵكى بابه‌تى ئه‌م گرێ به‌سته‌ له‌ لایه‌ن لایه‌نى
              یه‌كه‌م، ئه‌وا ده‌بێت لایه‌نى یه‌كه‌م بۆ هه‌ر ڕۆژێك دواكه‌وتن بڕی
              (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj.reject}
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              &nbsp;({numberWordsSorani3}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "دۆلاری  ئەمریکی"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "(دولار)"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "دیناری عێراقی"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "(دینار)"
               : ""}
              ) ) بدات به‌ لایه‌نى دووه‌م.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              8-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "23px",
               borderTop: "none",
              }}
             >
              له‌كاتى په‌شیمان بوونه‌وه‌ى هه‌ر لایه‌نێك له‌ لایه‌نه‌كانى
              گرێبه‌ست، ئه‌وا لایه‌نى په‌شیمان بڕی (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj.fee}
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              &nbsp; ({numberWordsSorani5}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "دۆلاری  ئەمریکی"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "(دولار)"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "(ID)"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "دیناری عێراقی"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "(دینار)"
               : ""}
              )) ده‌دات به‌ لایه‌نه‌كه‌ى تر كه‌ پێ ى ده‌وترێت ( شرط الجزائی )
              به‌ پێ ی ماده‌ى ( 92 ) له‌ یاسای شارستانی كارپێكراو له‌ هه‌رێمى
              كوردستان، به‌بێ هیچ حوكمێكی دادوه‌رى.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fkp" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
              }}
             >
              9-
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "4px",
               color: "black",
               fontWeight: "bold",
               textAlign: "justify",
               fontSize: "23px",
               borderTop: "none",
              }}
             >
              پاره‌ى باجی خانووبه‌ره‌ و باجی ده‌رامه‌ت و ئاو و كاره‌با و
              شاره‌وانی تایبه‌ت به‌ موڵكى ئاماژه‌پێكراو له‌ ئه‌ستۆى لایه‌نى
              یه‌كه‌مه‌، ئه‌گه‌ر به‌ پێچه‌وانه‌وه‌ ڕێكه‌وتن نه‌كرابوو.
             </td>
            </tr>
           </tbody>
          </table>
         </div>
        </div>
       </div>
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <div className="row">
        <div className="col-12">
         <table className="table">
          <tbody>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             10-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "23px",
              borderTop: "none",
             }}
            >
             ره‌سمی تۆمار كردن له‌ تۆمارى خانووبه‌ره‌ له‌ ئه‌ستۆى لایه‌نى دووه‌م
             ده‌بێت، ئه‌گه‌ر هاتوو به‌ پێچه‌وانه‌وه‌ ڕیًكه‌وتن نه‌كرابوو.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             11-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "23px",
              borderTop: "none",
             }}
            >
             ئه‌گه‌ر هاتوو موڵكى بابه‌تى گرێ به‌ست تۆمار نه‌كراو بوو له‌ تۆمارى
             خانووبه‌ره‌ ئه‌وا لایه‌نه‌كان ئازادن كه‌ به‌ چ شێوه‌یه‌ك خه‌رجی (
             تحویل ) كردنی موڵك ده‌گرنه‌ ئه‌ستۆ.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
             }}
            >
             12-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "23px",
              borderTop: "none",
             }}
            >
             لەکاتی هەبونی هەر کێشەیەک سەبارەت بەناوەرۆکی ئەم گرێبەستە پێویستە
             لەسەر هەردوولایەن سەرەتا بە شێوازی دانوستاندن و گفتوگۆ کێشەکە
             چارەسەر بکەن. بەڵام ئەگەر چارەسەر نەکرا ئەوا لەڕێگەی دادگاکانی
             هەولێر چارەسەر دەکرێ.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
              //
             }}
            >
             13-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "23px",
              borderTop: "none",
             }}
            >
             لایه‌نى یه‌كه‌م خاوه‌ن موڵك (فرۆشیار) ئه‌و موڵكه‌ى كه‌ ده‌یفرۆشێت
             ده‌بێت هی خۆى بێت یان ده‌سته‌ڵاتی فرۆشتنى هه‌بێت بەپێى
             به‌ڵگه‌نامه‌ى فه‌رمی وه‌ ڕۆژێك به‌ر له‌به‌روارى گرێبەست پێویسته‌
             وێنه‌ى نوێ ى تۆماری خانووبه‌ره‌ى لا بێت و پێشكه‌ش به‌ كڕیار و
             كۆمپانیای خانووبه‌ره‌ بكات.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
              //
             }}
            >
             14-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "23px",
              borderTop: "none",
             }}
            >
             كۆمپانیای (دیڤاین تایم) بڕی ( 1% کە دەکاتە) پاره‌ له‌ كۆى نرخی
             موڵكه‌كه‌ له‌ هه‌ر لایه‌نێكى ئه‌م گرێ به‌سته‌ وه‌رده‌گرێت له‌
             ئه‌نجامی ئه‌و خزمه‌ته‌ى پێشكه‌ش به‌ هه‌ردوو لایه‌نى گرێ به‌سته‌كه‌ى
             كردووه‌. وه‌ ئه‌وانیش له‌ ئه‌نجام دا گه‌یشتن به‌ ڕێكه‌وتن و گرێ
             به‌ستى كۆتایی.
            </td>
           </tr>
           {/*  */}
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
              //
             }}
            >
             15-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "23px",
              borderTop: "none",
             }}
            >
             پێویسته‌ هه‌ردوو لایه‌نى گرێ به‌ست ته‌واوى بڕگه‌كانى گرێ به‌ست به‌
             نیه‌ت پاكی جێ به‌جێ بكه‌ن.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
              //
             }}
            >
             16-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "23px",
              borderTop: "none",
             }}
            >
             كۆمپانیا‌ به‌ر پرسیار نیه‌ له‌ هه‌ر كێشه‌یه‌ك دروست بێت له‌ نێوان
             هه‌ردوو لایه‌نى گرێبه‌ست، به‌ڵام ئاماده‌ ده‌بێت له‌كاتى پێویست له‌
             دادگاى تایبه‌تمه‌ند كه‌ ڕوون كردنه‌وه‌ى ڕاست و دروست و بێ لایه‌ن
             پێشكه‌ش به‌ دادگا ده‌كات.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
              //
             }}
            >
             17-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "23px",
              borderTop: "none",
             }}
            >
             له‌كاتی بوونى هه‌ر كێشه‌یه‌كی یاسایی له‌ سه‌ر موڵك بابه‌تى گرێ
             به‌ست ئه‌وا لایه‌نى یه‌كه‌م ده‌بێت ته‌واوى پاره‌ى لایه‌نى دووه‌م
             بداته‌وه‌ وه‌ قه‌ره‌بووش بكرێته‌وه‌ ئه‌گه‌ر زیانی به‌ركه‌وتبێت،
             هه‌رچه‌نده‌ ئه‌م كێشه‌ یاسایی یه‌ ده‌ستى لایه‌نى یه‌كه‌م تێدا
             نه‌بووه‌.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
              //
             }}
            >
             18-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "23px",
              borderTop: "none",
             }}
            >
             له‌ كاتی بوونى هه‌ر كێشه‌یه‌ك ئه‌وا دادگاى ئه‌و شوێنه‌ تایبه‌تمه‌ند
             ده‌بێت كه‌وا ( موڵكى ) بابه‌تى گرێ به‌سته‌كه‌ى لێ یه‌.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
              //
             }}
            >
             19-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "23px",
              borderTop: "none",
             }}
            >
             ئه‌م گرێ به‌سته‌ له‌ هه‌ولێر له‌ به‌روارى (
             <Time
              value={sell_invoice_obj.createdAt}
              format="YYYY-MM-DD"
              style={{
               fontSize: "22px",
               color: "#342800",
               fontWeight: "bold",
              }}
             />
             ) واژوو كرا له‌ نێوان هه‌ردوولایه‌نى گرێ به‌ست به‌ ته‌واوى
             ڕه‌زامه‌ندی خۆیان له‌سه‌ر ته‌واوى به‌نده‌كان .
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "18px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fkp" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",
              //
             }}
            >
             20-
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "4px",
              color: "black",
              fontWeight: "bold",
              textAlign: "justify",
              fontSize: "23px",
              borderTop: "none",
             }}
            >
             ئه‌م گرێ به‌سته‌ له‌ ( 20 ) خاڵ و ( 2 ) لاپه‌ره‌ڕه‌ پێك هاتووه‌.
            </td>
           </tr>
          </tbody>
         </table>
        </div>
       </div>
       <div className="form-inline">
        <label
         style={{
          fontSize: "19px",
          color: "black",
          textAlign: "justify",
          fontWeight: "bold",
         }}
         className="form-label d-flex justify-content-start"
        >
         {change_Lang("note")}&nbsp;:{sell_invoice_obj.note}
        </label>
       </div>
       <br />
       <br />
       <div
        className="row mt-3"
        style={{
         width: "100%",
        }}
       >
        <div className="form-group d-flex justify-content-center col-4">
         <label
          style={{
           fontSize: "20px",
           color: "#000",
           fontWeight: "bold",
          }}
          className="form-label"
         >
          لایەنی یەکەم (فرۆشیار)
         </label>
        </div>
        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "23px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           {change_Lang("Contract Organizer")}
          </label>
         </div>
        </div>{" "}
        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           لایەنی دووەم (کڕیار)
          </label>
         </div>
        </div>
       </div>
       <div
        className="row"
        style={{
         width: "100%",
        }}
       >
        <div className="col-4 form-group d-flex justify-content-center">
         <label
          style={{
           fontSize: "20px",
           color: "#000",
          }}
          className="form-label"
         >
          {sell_invoice_obj.firstname}
         </label>
        </div>
        <div className="col-4 form-group d-flex justify-content-center">
         <label
          style={{
           fontSize: "20px",
           color: "#000",
          }}
          className="form-label"
         >
          {`${sell_invoice_obj.agentId && sell_invoice_obj.agentId.fname} ${
           sell_invoice_obj.agentId && sell_invoice_obj.agentId.lname
          }`}
         </label>
        </div>

        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "20px",
            color: "#000",
           }}
           className="form-label"
          >
           {sell_invoice_obj.secondname}
          </label>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  index_sell_contract: state.Invoice_Reducer.index_sell_contract,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_krd: state.HelperReducer.name_krd,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(SellPrintKurdish);
